export const menuMobile = () => {
    if($(window).width() < 992) {
        $('.ubermenu-item-level-0 > .ubermenu-submenu').each(function() {
            const el = $(this)
    
            el.append('<div class="btn-back"><i class="bi bi-arrow-left"></i> Back</div>')
        })

        $('.ubermenu-item-level-0').each(function() {
            const el = $(this)

            el.find('.btn-back').click(() => {
                el.removeClass('ubermenu-active')
            })
        })
    }
}

export const menuSearch = () => {
    $('header .btn-search').click((e) => {
        e.stopPropagation();
        $('header .search-form').addClass('show')
    })

    $(document).click((e) => {
        if (!$(e.target).closest('header .search-form').length && !$(e.target).closest('header .btn-search').length) {
            $('header .search-form').removeClass('show')
        }
    })
}

export const menuSticky = () => {
    const stickyMenuActiveOld = () => {
        let activeId = null

        $('.page-for-organisations #main section').each(function() {
            const el = $(this),
                elId = el.attr('id'),
               elTop = el.offset().top,
            elHeight = el.outerHeight()
    
            if($(window).scrollTop() >= (elTop - 100) && $(window).scrollTop() < elTop + elHeight) {
                activeId = elId
            }
        })
    
        $('.section-sticky-menu li a').removeClass('active')
        if(activeId) {
            $('.section-sticky-menu li a[href="#' + activeId + '"]').addClass('active')
        }
    }

    const stickyMenuActive = () => {
        const eL = $('.single-certifications .sticky-menu li div, .page-for-organisations .sticky-menu li div')

        eL.each(function() {
            let el = $(this)
    
            el.click(() => {
                $('html, body').stop()
                
                $('html, body').animate({
                    scrollTop: $('#' + el.attr('data-target')).offset().top - 38
                }, 400)
            })
        })
    
        eL.each(function() {
            let el = $(this),
                targetOffset = $('#' + el.attr('data-target')).offset().top - 40,
                targetHeight = $('#' + el.attr('data-target')).height(),
                currentScrollPosition = $(document).scrollTop()
            
            if(currentScrollPosition >= targetOffset && currentScrollPosition < targetOffset + targetHeight) {
                eL.removeClass('active')
                el.addClass('active')
            } else {
                el.removeClass('active')
            }
        })
    }

    stickyMenuActive()
    $(window).scroll(() => {
        stickyMenuActive()
    })
}
